import React, { useState } from 'react';

import { Button } from 'antd';

import UpdateMinimumRequirementProductField from './UpdateMinimumRequirementProductField';
import UpdateMinimumRequirementProductGalleryModal from './UpdateMinimumRequirementProductGalleryModal';
import UpdateMinimumRequirementProductDocumentModal from './UpdateMinimumRequirementProductDocumentModal';

import { useUpdateMemberAdditionalRequirements } from 'hooks/useUpdateMemberAdditionalRequirements';

import { useIntl } from 'react-intl';
import messages from 'i18n/messages/home';
import { RequiredBrand } from 'common/components/product-add/make-product-active/RequiredBrand';

const OpenUpdateMinimumRequirementButton = (props) => {
  const intl = useIntl();
  const { openErrorUrl } = useUpdateMemberAdditionalRequirements();

  const {
    item,
    entityData,
    productDetail,
    requiredForm,
    onInvalidateProductValidation,
  } = props;

  const [modalVisible, setModalVisible] = useState(false);

  const onClickOpenBtn = () => {
    openModal();
    openEditMemberPage();
  };

  const openModal = () => {
    UpdateAdditionalRequirementModal && setModalVisible(true);
  };

  const openEditMemberPage = () => {
    openErrorUrl({
      fieldName: item.id,
      entityId: entityData?.id,
    });
  };

  const updateModalCollection = {
    product_planoimage: (
      <UpdateMinimumRequirementProductGalleryModal
        visible={modalVisible}
        setVisible={setModalVisible}
        entity={entityData}
        productDetail={productDetail}
        type='Planogram'
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
    product_additionalimage: (
      <UpdateMinimumRequirementProductGalleryModal
        visible={modalVisible}
        setVisible={setModalVisible}
        entity={entityData}
        productDetail={productDetail}
        type='Additional'
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
    product_marketingimage: (
      <UpdateMinimumRequirementProductGalleryModal
        visible={modalVisible}
        setVisible={setModalVisible}
        entity={entityData}
        productDetail={productDetail}
        type='Marketing'
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
    product_anyimage: (
      <UpdateMinimumRequirementProductGalleryModal
        visible={modalVisible}
        setVisible={setModalVisible}
        entity={entityData}
        productDetail={productDetail}
        type='Marketing'
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
    product_document: (
      <UpdateMinimumRequirementProductDocumentModal
        productDetail={productDetail}
        visible={modalVisible}
        setVisible={setModalVisible}
        entity={entityData}
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
    product_brand: <RequiredBrand formInstance={requiredForm} />,
    product_upcgtin: (
      <UpdateMinimumRequirementProductField
        productDetail={productDetail}
        visible={modalVisible}
        setVisible={setModalVisible}
        entityId={entityData?.id}
        item={item}
        onInvalidateProductValidation={onInvalidateProductValidation}
      />
    ),
  };

  const UpdateAdditionalRequirementModal =
    updateModalCollection[item?.id?.toLowerCase()];

  const isProductBrand = item?.id?.toLowerCase() === 'product_brand';

  return (
    <>
      {/* Product brand already had a specific component */}
      {isProductBrand ? null : (
        <Button type='primary' danger size='small' onClick={onClickOpenBtn}>
          {intl.formatMessage(messages.previewRequirementsOpenButton)}
        </Button>
      )}
      {UpdateAdditionalRequirementModal
        ? UpdateAdditionalRequirementModal
        : null}
    </>
  );
};

export default OpenUpdateMinimumRequirementButton;
